import { Injectable } from '@angular/core';

import { Docorga } from '@docorga-v1/docorga-common';
@Injectable()
export class DataService extends Docorga.services.DataService {
  constructor() {
    super();
  }
}
